import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const alertVariants = cva(
  "tw:group/alert! tw:relative! tw:grid! tw:w-full! tw:gap-0.5! tw:rounded-lg! tw:border! tw:px-2! tw:py-1.5! tw:text-left! tw:text-xs/relaxed! tw:has-data-[slot=alert-action]:relative! tw:has-data-[slot=alert-action]:pr-18! tw:has-[!>svg]:grid-cols-[auto_1fr] tw:has-[!>svg]:gap-x-1.5 tw:*:[svg]:row-span-2! tw:*:[svg]:translate-y-0.5 tw:*:[svg]:text-current! tw:*:[svg:not([class*=size-])]:size-3.5!",
  {
    variants: {
      variant: {
        default: "tw:bg-card! tw:text-card-foreground!",
        destructive:
          "tw:bg-card! tw:text-destructive! tw:*:data-[slot=alert-description]:text-destructive/90! tw:*:[svg]:text-current!",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  )
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        "tw:font-medium tw:group-has-[!>svg]/alert:col-start-2 tw:[&_a]:underline! tw:[&_a]:underline-offset-3! tw:[&_a]:hover:text-foreground!",
        className
      )}
      {...props}
    />
  )
}

function AlertDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        "tw:text-xs/relaxed! tw:text-balance! tw:text-muted-foreground! tw:md:text-pretty! tw:[&_a]:underline! tw:[&_a]:underline-offset-3! tw:[&_a]:hover:text-foreground! tw:[&_p:not(:last-child)]:mb-0!",
        className
      )}
      {...props}
    />
  )
}

function AlertAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-action"
      className={cn("tw:absolute! tw:top-1.5! tw:right-2!", className)}
      {...props}
    />
  )
}

export { Alert, AlertTitle, AlertDescription, AlertAction }
